import { ChallengesReducer } from "reducers/challenges";
import { useAppSelector } from "store";

export const useIdeaQueryParams = (ideaViewType: string) => {
  const challengesReducer: ChallengesReducer = useAppSelector(
    (state) => state.challenges,
  );
  const {
    tagFilter,
    ideaFilter: query,
    ideaIncludes: filter,
    ideaOrder: sort,
    ideaOrderDirection: sortDirection,
    ideaPage: page,
    labelsFilter: labels,
    ideaLimit: limit,
    ideaFieldChoices: fieldChoices,
    projectBoardLanesFilter,
    groupFilter,
    orgFilter,
    projectBoardFilter,
    adminHasCommented,
    impactFilter,
  } = challengesReducer;

  return {
    page: ideaViewType === "board" ? 1 : page,
    query,
    tags: tagFilter,
    filter: filter || "all",
    sort,
    sortDirection,
    labels,
    groupFilter,
    orgFilter,
    fieldChoices,
    limit: ideaViewType === "board" ? 10000 : limit,
    adminHasCommented,
    projectBoardFilter,
    projectBoardLanesFilter,
    impactFilter,
  };
};
